export default "<contact-info\r\n\tcontact=\"$ctrl.contact\"\r\n\tis-readonly=\"$ctrl.isReadonly\"\r\n></contact-info>\r\n";